import api from '@/api/api';

export default {
    getMenus() {
        return api.get(route('menu-customizado'));
    }
};
